"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragAndDrop = void 0;

var _Container = _interopRequireDefault(require("./Container"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DragAndDrop = {
  Container: _Container.default,
  reorder: _utils.reorder,
  remove: _utils.remove
};
exports.DragAndDrop = DragAndDrop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/form/drag_and_drop/index.js
// module id = 701
// module chunks = 0 15 16 17 18